import styled from 'styled-components'

export const Layout = styled.div`
  position: absolute;
  pointer-events: auto;
`

export const Button = styled.button`
  display: inline-flex;

  gap: var(--space-250);
  justify-content: center;
  align-items: center;

  border-radius: var(--radius-brand);
  padding: 0 var(--space-250);

  height: 32px;

  background: var(--bg-brand);

  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-on-brand);

  &:hover {
    background: var(--bg-brand-hover);
  }
`
